import {
  Modal as MUIModal,
  Typography,
  Button,
  Box,
  Stack,
  Link,
} from "@mui/material";
import {
  ModalCloseIcon,
  RightArrowIcon,
  ThumbsUpIcon,
} from "../../../../@lib/icons";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 530,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  py: 3,
  px: 1,
};

function SuccessModal({ isOpen, onClose, message, path }: any) {
  return (
    <MUIModal
      open={isOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Stack
          sx={{ display: "flex", justifyContent: "end", alignItems: "end" }}
        >
          <Button onClick={onClose} sx={{ padding: "0px", minWidth: "auto" }}>
            <ModalCloseIcon />
          </Button>
        </Stack>
        <Stack
          direction="column"
          sx={{ padding: "10px 60px" }}
          alignItems="center"
        >
          <ThumbsUpIcon />
          <Typography id="modal-modal-title" sx={{ fontSize: "16px" }}>
            {message}
          </Typography>
        </Stack>
        <Link
          id="modal-modal-description"
          href={path}
          sx={{
            mt: 2,
            color: "#F6A000",
            fontSize: "14px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Back to Dashboard
          <div style={{ marginLeft: "10px" }}>
            <RightArrowIcon />
          </div>
        </Link>
      </Box>
    </MUIModal>
  );
}

export { SuccessModal };
